import React from 'react'
import styles from './Blogmain.module.css'
// import profile_pic from '../../Assets/Images/profile.jpg';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
// const blog = {
//     title:"Begining of hashnode project ",
//     thumbnai:"https://ayushirawat.com/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1632976797875%2F8W2PQcsdd.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75"
// }
const Blogmain = ({ post }) => {
    // console.log(post);
    return (
        <div className={styles.blogmain}>
            {/* <div className={styles.thumbnail}>
                <img src={blog.thumbnai} alt="" />
            </div>
            <div className={styles.blogtext}>
                <h1 style={{fontWeight:"bolder"}}>{blog.title}</h1>
            </div> */}
            <div className={styles.button_div}>
                <svg class="css-17mdxl4" viewBox="0 0 24 24"><g fill-rule="evenodd"><path d="M19.174 11.59l-2.207-2.208 1.103-2.207 3.587 3.587a1.17 1.17 0 010 1.655l-4.415 4.416a1.17 1.17 0 01-1.655-1.656l3.587-3.587z" opacity=".56"></path><path d="M15.588 6.343a1.17 1.17 0 011.655 0l.828.828-9.658 9.657a1.17 1.17 0 01-1.655 0L5.93 16l9.658-9.657zm-4.14 3.035l-1.655 1.656-2.208-2.208-2.76 2.76 2.208 2.207L5.93 16l-3.587-3.587a1.17 1.17 0 010-1.655l4.415-4.415a1.17 1.17 0 011.655 0l3.036 3.035z"></path></g></svg>
               <h5>Featured on Hashnode</h5>
            </div>
            <div className={styles.blogdetail}>
                <div className={styles.blogprofile}>
                    <img
                        src={post?.author?.profile_pic}
                        alt="profile"
                        height="50"
                        width="50"
                    />
                </div>
                <div className={styles.blogother}>
                    <h5>{ post?.author?.name}</h5>
                    <div className={styles.published}>{`Published on ${new Date().toISOString().slice(0, 10)}` }</div>
                    <div className={styles.blog_icons}>
                        <TwitterIcon style={{fontSize:"18px"}} className={styles.icon} />
                        <GitHubIcon style={{ fontSize: "16px" }} className={styles.icon} />
                        <div className={styles.blogSub} >6 min read</div>
                    </div>
              </div>
            </div>
        </div>
    )
}

export default Blogmain
